export default __webpack_public_path__ + "static/media/p7.c651b82d.jpg";